module.exports = __webpack_public_path__ + "img/pr-5.1518366f.png";